import React from "react";
import { motion } from "framer-motion";
import { cn } from "./cn";

export default function Switch({ checked = false, onChange, disabled = false, className }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors outline-none",
        "focus-visible:ring-2 focus-visible:ring-accent/40 disabled:opacity-50",
        checked ? "bg-accent" : "bg-line",
        className
      )}
    >
      <motion.span
        layout
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
        className={cn(
          "inline-block h-5 w-5 rounded-full bg-white shadow",
          checked ? "ml-[22px]" : "ml-0.5"
        )}
      />
    </button>
  );
}
